<template>
  <v-dialog v-model="editDialog" persistent width="1024">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" dark class="mx-4" v-bind="attrs" v-on="on">
        Add Assyst Version
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="text-h5 accent lighten-2">
        {{ formTitle }}
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="6" class="text-center">
              <v-text-field v-model="editedVersion.assyst_version" label="Name" />
              <v-text-field v-model="editedVersion.azure_package_name" label="Azure Package" />
              <v-text-field v-model="editedVersion.major_java_ver" label="Major Java Version" />             
              <v-text-field v-model="editedVersion.build_number" label="Build Number" />
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="computedExpiryDate"
                    label="Support Expires"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="editedVersion.expiry_date"
                  @input="dateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="text-center">
              <v-text-field v-model="editedVersion.assyst_package_name" label="Package" />
              <v-text-field v-model="editedVersion.java_version" label="Java Version" />
              <v-text-field v-model="editedVersion.min_java_ver" label="Minor Java Version" />
              <v-switch
                v-model="editedVersion.released"
                label="Released"
                true-value="y"
                false-value="n"
              />
            </v-col>
            <v-col cols="12" sm="12" md="12" class="text-center">
              <v-textarea v-model="editedVersion.notes" label="Notes" />
            </v-col>
          </v-row>
          <v-row class="my-2">
            <v-subheader>
              Problems
            </v-subheader>
          </v-row>
          <v-divider />
          <v-row
            dense
          >
            <v-col
              v-for="(problem, i) in problems"
              :key="`problem-${i}`"
              cols="12"
              sm="3"
              md="2"
            >
              <v-checkbox
                v-model="editedVersion.related_problems"
                hide-details
                :label="problem.problem_ref"
                :value="problem.problem_id"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close"> CANCEL </v-btn>
        <v-btn color="accent" @click="save"> CONFIRM </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import axios from 'axios'
  import { authHeader } from '@/util/helpers'
  import getEnv from '@/util/env'
  // import { get, sync } from 'vuex-pathify'
  const host = getEnv('VUE_APP_API_HOST')
  export default {
    name: 'AssystSoftwareDialog',
    data () {
      return {
        editDialog: false,
        dateMenu: false,
        editedIndex: -1,
        editedVersion: {
          assyst_version: '',
          assyst_package_name: '',
          azure_package_name: '',
          java_version: '',
          major_java_ver: 8,
          min_java_ver: 202,
          build_number: '',
          released: 'n',
          related_problems: [],
          notes: '',
          expiry_date: new Date(new Date().setFullYear(new Date().getFullYear() + 2)).toISOString().substring(0,10)
        },
        defaultVersion: {
          assyst_version: '',
          assyst_package_name: '',
          azure_package_name: '',
          java_version: '',
          major_java_ver: 8,
          min_java_ver: 202,
          build_number: '',
          released: 'n',
          related_problems: [],
          notes: '',
          expiry_date: new Date(new Date().setFullYear(new Date().getFullYear() + 2)).toISOString().substring(0,10)
        },
      }
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Assyst Version' : 'Edit Assyst Version'
      },
      software () {
        return this.$store.getters['software/assyst']
      },
      problems () {
        return this.$store.getters['software/assyst_problems']
      },
      computedExpiryDate () {
        if (this.editedVersion.expiry_date !== '') {
          return this.formatDate(this.editedVersion.expiry_date)
        }
        return this.formatDate(Date.now())
      }
    },
    methods: {
      formatDate (date) {
        if (!date) return null
        const d = new Date(date)

        const [year, month, day] = [
          d.getFullYear(),
          d.getMonth() + 1,
          d.getDate(),
        ]
        return `${day}/${month}/${year}`
      },
      editVersion: function (software) {
        let problems = []
        software.assystProblems.forEach(element => {
          problems.push(element.problem_id)
        });
        software.related_problems = problems
        this.editedIndex = this.software.indexOf(software)
        this.editedVersion = Object.assign({}, software)
        this.editedVersion.expiry_date = software.expiry_date.substring(0,10)
        this.editDialog = true
      },
      close () {
        this.editDialog = false
        this.$nextTick(() => {
          this.editedVersion = Object.assign({}, this.defaultVersion)
          this.editedIndex = -1
        })
      },
      save: function() {
        delete this.editedVersion.contracts 
        if (this.editedVersion.notes === null) {
          this.editedVersion.notes = ''
        }
        if (this.editedIndex > -1) {
          this.updateVersion()
        } else {
          this.createVersion()
        }
        this.close()
      },
      updateVersion: function () {
        axios
          .put(
            `${host}/v2/assyst_software/${this.editedVersion.assyst_software_id}`,
            this.editedVersion,
            {
              headers: authHeader(),
            }
          )
          .then(() => {
            this.$snackbar.showMessage({ content: 'Assyst version has been updated', color: 'success', timeout: 5000 })
            this.$store.dispatch('software/load')
          })
          .catch((err) => {
            this.$errordialog.showMessage({ content: err.response.data.message, color: 'error', title: 'Oops! Something went wrong.' })
          })
      },
      createVersion: function () {
        axios
          .post(
            `${host}/v2/assyst_software/new`,
            this.editedVersion,
            {
              headers: authHeader(),
            }
          )
          .then(() => {
            this.$snackbar.showMessage({ content: 'Assyst version has been created', color: 'success', timeout: 5000 })
            this.$store.dispatch('software/load')
          })
          .catch((err) => {
            this.$errordialog.showMessage({ content: err.response.data.message, color: 'error', title: 'Oops! Something went wrong.' })
          })
      }
    }
  }
</script>